import {AsyncStateError, AsyncStateLoading, AsyncStateSuccess} from '../enums/asyncState'
import {useSetAsyncState} from '../states/AsyncContext'
import {useEffectEvent} from './useEffectEvent'
import {useErrorHandler} from './useErrorHandler'

type Hook = (...args: any) => Promise<void>

export function useAsyncSubmit(callback: (...args: any) => Promise<void>): Hook {
  const setAsyncState = useSetAsyncState()
  const errorHandler = useErrorHandler()

  return useEffectEvent(async (...args: any) => {
    setAsyncState(AsyncStateLoading)
    try {
      await callback(...args)
      setAsyncState(AsyncStateSuccess)
    } catch (err: any) {
      setAsyncState(AsyncStateError)
      errorHandler(err)
    }
  })
}
